export function initArticleProgressBar() {
  const article = document.querySelector(".js-article-content");
  const progressBar = document.querySelector(".js-post-progress_bar");

  if (!article || !progressBar) return;

  let articleTop = 0;
  let articleHeight = 0;
  let viewportHeight = window.innerHeight;
  let ticking = false;

  function calculateSizes() {
    const rect = article.getBoundingClientRect();
    articleTop = rect.top + window.scrollY;
    articleHeight = article.offsetHeight;
    viewportHeight = window.innerHeight;
  }

  function updateProgress() {
    const scrollY = window.scrollY;

    const scrolledIntoArticle = scrollY + viewportHeight - articleTop;

    const scrollRange = articleHeight + viewportHeight;

    let progress = scrolledIntoArticle / scrollRange;

    progress = Math.min(Math.max(progress, 0), 1);

    progressBar.style.transform = `scaleX(${progress})`;

    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(updateProgress);
      ticking = true;
    }
  }

  calculateSizes();
  updateProgress();

  window.addEventListener("scroll", onScroll);
  window.addEventListener("resize", () => {
    calculateSizes();
    updateProgress();
  });
}
